<div class="flex-wrapper">
  <ion-item class="ion-no-padding">
    <ion-label>{{ node.title }}</ion-label>
    <p *ngIf="node.description">
      <small>{{ node.description }}</small>
    </p>
  </ion-item>
  <ion-button (click)="openContactPicker()">
    <ion-icon slot="icon-only" name="contact"></ion-icon>
  </ion-button>
</div>
<ion-grid>
  <ion-row>
    <ion-col>
      <ion-item class="ion-no-padding" *ngIf="contact.name">
        <ion-label floating>{{ 'audit.node.contact.name' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="name"></ion-input>
      </ion-item>
      <ion-item class="ion-no-padding" *ngIf="contact.organization">
        <ion-label floating>{{ 'audit.node.contact.organization' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="organization"></ion-input>
      </ion-item>
      <ion-item class="ion-no-padding" *ngIf="contact.function">
        <ion-label floating>{{ 'audit.node.contact.function' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="function"></ion-input>
      </ion-item>
    </ion-col>
    <ion-col>
      <ion-item class="ion-no-padding" *ngIf="contact.street">
        <ion-label floating>{{ 'address.street' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="street"></ion-input>
      </ion-item>
      <ion-item class="ion-no-padding" *ngIf="contact.zip">
        <ion-label floating>{{ 'address.postalCode' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="zip"></ion-input>
      </ion-item>
      <ion-item class="ion-no-padding" *ngIf="contact.city">
        <ion-label floating>{{ 'address.city' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="city"></ion-input>
      </ion-item>
    </ion-col>
    <ion-col>
      <ion-item class="ion-no-padding" *ngIf="contact.phone">
        <ion-label floating>{{ 'audit.node.contact.phone' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="phone" type="tel"></ion-input>
      </ion-item>
      <ion-item class="ion-no-padding" *ngIf="contact.fax">
        <ion-label floating>{{ 'audit.node.contact.fax' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="fax" type="tel"></ion-input>
      </ion-item>
      <ion-item class="ion-no-padding" *ngIf="contact.mobile">
        <ion-label floating>{{ 'audit.node.contact.mobile' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="mobile" type="tel"></ion-input>
      </ion-item>
      <ion-item class="ion-no-padding" *ngIf="contact.email">
        <ion-label floating>{{ 'audit.node.contact.email' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="email" type="email"></ion-input>
      </ion-item>
      <ion-item class="ion-no-padding" *ngIf="contact.website">
        <ion-label floating>{{ 'audit.node.contact.mobile' | translate }}</ion-label>
        <ion-input type="text" [(ngModel)]="mobile"></ion-input>
      </ion-item>
    </ion-col>
  </ion-row>
</ion-grid>
